import React from 'react';

interface IconProjectManagerProps {
    iconClasses?: string;
}

/** Suit-and-tie person with overlapping gear — Project Manager (PM). */
const IconProjectManager: React.FC<IconProjectManagerProps> = ({ iconClasses }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-project-manager ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            {/* Head */}
            <circle cx="38" cy="19" r="11" stroke="currentColor" strokeWidth="5" />

            {/* Jacket bust: shoulders, sides, hem; right side opens into gear */}
            <path
                d="M15 76
                   V50
                   C15 40 23 34 32 34
                   H35
                   L38 48
                   L41 34
                   H45
                   C52 34 57 38 58 45"
                stroke="currentColor"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15 76 H48"
                stroke="currentColor"
                strokeWidth="5"
                strokeLinecap="round"
            />

            {/* Necktie */}
            <path
                d="M34.5 36.5 38 41 41.5 36.5"
                stroke="currentColor"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M38 41 34.2 68 38 74.5 41.8 68 Z"
                stroke="currentColor"
                strokeWidth="4"
                strokeLinejoin="round"
            />

            {/* Gear (8 blocky teeth) */}
            <path
                d="M59.7 50.38 63.55 41.72 70.45 41.72 74.3 50.38 75 50.67 83.85 47.27 88.73 52.15 85.33 61 85.62 61.7 94.28 65.55 94.28 72.45 85.62 76.3 85.33 77 88.73 85.85 83.85 90.73 75 87.33 74.3 87.62 70.45 96.28 63.55 96.28 59.7 87.62 59 87.33 50.15 90.73 45.27 85.85 48.67 77 48.38 76.3 39.72 72.45 39.72 65.55 48.38 61.7 48.67 61 45.27 52.15 50.15 47.27 59 50.67 Z"
                stroke="currentColor"
                strokeWidth="5"
                strokeLinejoin="round"
            />
            <circle cx="67" cy="69" r="12.5" stroke="currentColor" strokeWidth="5" />
        </svg>
    );
};

export default IconProjectManager;
